import { Component, OnInit } from "@angular/core";
import { TokenService } from "../../core/services/token.service";
import { AuthService } from "../../core/services/auth.service";
import { Router } from "@angular/router";
import { NuevoUsuario } from "../../core/models/nuevo-usuario";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-registro",
  templateUrl: "./registro.component.html",
  styleUrls: ["./registro.component.css"],
})
export class RegistroComponent implements OnInit {
  nuevoUsuario: NuevoUsuario;
  nombre: string;
  nombreUsuario: string;
  email: string;
  password: string;
  errMsj: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {}

  onRegister(): void {
    this.nuevoUsuario = new NuevoUsuario(
      this.nombre,
      this.nombreUsuario,
      this.email,
      this.password
    );
    this.authService.nuevo(this.nuevoUsuario).subscribe(
      (data) => {
        this.toastr.success("Cuenta Creada", "OK", {
          timeOut: 3000,
          positionClass: "toast-top-center",
        });

        this.router.navigate(["/login"]);
      },
      (err) => {
        this.errMsj = err.error.mensaje;
        this.toastr.error(this.errMsj, "Fail", {
          timeOut: 3000,
          positionClass: "toast-top-center",
        });
      }
    );
  }
}
